import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RouteService {
  constructor(private route: ActivatedRoute) {}

  getQueryParam(paramName: string): string | null {
    let queryParam = null;
    this.route.queryParams.subscribe(params => {
      queryParam = params[paramName] ? params[paramName] : null;
    });

    return queryParam;
  }
}
